import { FileClient } from "../RestClient";

export type B030030Request = {
  seikyushimeYmd: string;
  seikyushoType: string;
  outputFormat: string;
} & Partial<{
  urikakeshainCd: string;
  seikyuCdFrom: string;
  seikyushitenCdFrom: string;
  seikyuCdTo: string;
  seikyushitenCdTo: string;
}>;

export const B030030Print = (props: B030030Request) => {
  return FileClient.get("b030030/print", { params: props });
};
